import { createContext, useContext, useState } from 'react';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [role, setRole] = useState(localStorage.getItem('admin_role'));
  const [name, setName] = useState(localStorage.getItem('admin_name'));
  const login = (t, r, n) => {
    localStorage.setItem('admin_token', t);
    localStorage.setItem('admin_role', r);
    localStorage.setItem('admin_name', n);
    setToken(t); setRole(r); setName(n);
  };
  const logout = () => {
    localStorage.clear();
    setToken(null); setRole(null); setName(null);
  };
  return (
    <AuthContext.Provider value={{ token, role, name, login, logout, isAuth: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
